import { Avatar, Badge, Box, Button, Flex, FormatNumber, Grid, GridItem, HStack, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { UI } from "components";
import useCart from "hooks/useCart";
import moment, { duration } from "moment";
import Moment from "react-moment";
import Cart from "./cart";
import ChangeSupplier from "./supplier/change";
import { useData } from '../../hooks/useData'
import useCashBalance from "hooks/useCashBalance";

export default function Heading({ supplier }){

    const cart = useCart()
    const { data, setCart } = useData()
    const cash = useCashBalance()
    const cash_available = (cash.data - cart.data?.total_amount) <= 0 ? 0 : cash.data - cart.data?.total_amount

    const changeSupplier = useDisclosure()

    return(
    <>
    <Cart open={data?.cart?.open} onClose={() => setCart({ open: false })} />
    <ChangeSupplier {...changeSupplier} />

    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)' }} gap={4} mb={4} pb={4} borderBottomWidth={1}>

        <GridItem>

            <HStack gap={3}>
                <UI.Avatar name={supplier?.name ?? '...'} src="/icon.png" />
                <Box>
                    <Text fontSize="md" fontWeight="bold" mb={-1}>{supplier?.name ?? '...'}</Text>
                    <Badge size="xs" colorPalette="orange">Distribuidor oficial</Badge>
                    {supplier?.free_choice && (
                        <Button size="xs" variant="ghost" colorPalette="orange" mt={1} onClick={changeSupplier.onOpen}>
                            <UI.Icon name="edit" /> Trocar fornecedor
                        </Button>
                    )}
                </Box>
            </HStack>

        </GridItem>

        <GridItem display="flex" justifyContent={{ base: 'flex-start', md: 'flex-start', lg: 'right' }}>

            <HStack gap={4}>
                <UI.Popover.PopoverRoot>
                    <UI.Popover.PopoverTrigger>
                        <UI.Pressable>
                            <Box>
                                <Text fontSize="xs" color="GrayText">Tempo restante:</Text>
                                <Badge size="lg" colorPalette="red"><UI.Icon name="timer" /> <Moment fromNow interval={1000} children={cart.data?.cart_expire_at} /></Badge>
                            </Box>
                        </UI.Pressable>
                    </UI.Popover.PopoverTrigger>
                    <UI.Popover.PopoverContent>
                        <UI.Popover.PopoverArrow />
                        <UI.Popover.PopoverBody>
                            <Stack>
                                <Text fontWeight="bold">Porque tempo restante?</Text>
                                <Text>
                                    A partir do momento que você adiciona um produto à sacola, o item será reservado no estoque da Matriz 
                                    para que não ocorram vendas acima da capacidade.
                                </Text>
                                <Text fontWeight="bold">O que acontece quando o tempo acaba?</Text>
                                <Text>
                                    Caso você não finalize o pedido antes de o tempo acabar, seu carrinho será reiniciado.
                                </Text>
                                <Text>
                                    Fazemos isso para garantir que todos tenham a mesma oportunidade de compra.
                                </Text>
                            </Stack>
                        </UI.Popover.PopoverBody>
                    </UI.Popover.PopoverContent>
                </UI.Popover.PopoverRoot>

                <UI.Popover.PopoverRoot>
                    <UI.Popover.PopoverTrigger>
                        <UI.Pressable>
                            <Box>
                                <Text fontSize="xs" color="GrayText">Saldo disponível:</Text>
                                <Badge size="lg" colorPalette={cash_available <= 0 ? 'red' : 'green'}><UI.Number.Amount value={cash_available} /></Badge>
                            </Box>
                        </UI.Pressable>
                    </UI.Popover.PopoverTrigger>
                    <UI.Popover.PopoverContent>
                        <UI.Popover.PopoverArrow />
                        <UI.Popover.PopoverBody>
                            <Stack>
                                <Text fontWeight="bold">Saldo haver</Text>
                                <Text>
                                    Os pedidos agora tem o saldo haver descontado no ato do pedido. Aqui você pode ver o quanto ainda tem disponível para gastar.
                                </Text>
                                <Text fontWeight="bold">E o excedente?</Text>
                                <Text>
                                    O que você não gastar, ficará disponível para o próximo pedido. Caso o valor do pedido seja maior que o saldo haver, o restante 
                                    será convertido em uma transação pix.
                                </Text>
                            </Stack>
                        </UI.Popover.PopoverBody>
                    </UI.Popover.PopoverContent>
                </UI.Popover.PopoverRoot>
                
                <Box>
                    <Text fontSize="xs" color="GrayText">Total:</Text>
                    <Text fontSize="md" fontWeight="bold" color="orange.fg"><FormatNumber value={cart.data?.total_amount / 100} style="currency" currency="BRL" /></Text>
                </Box>

                <Box>
                    <Button hideBelow="sm" size="sm" variant="outline" colorPalette="orange" loading={cart.isFetching} onClick={() => setCart({ open: true })}><UI.Icon name="cart" /> Sacola</Button>
                </Box>
            </HStack>

        </GridItem>

        <GridItem hideFrom="sm"><Button w="100%" size="sm" variant="outline" colorPalette="orange" loading={cart.isFetching} onClick={() => setCart({ open: true })}><UI.Icon name="cart" /> Sacola</Button></GridItem>

    </Grid>
    </>
    )
}